import { render, staticRenderFns } from "./Ogp.vue?vue&type=template&id=6dec6712&scoped=true"
import script from "./Ogp.vue?vue&type=script&lang=js"
export * from "./Ogp.vue?vue&type=script&lang=js"
import style0 from "./Ogp.vue?vue&type=style&index=0&id=6dec6712&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dec6712",
  null
  
)

export default component.exports